import React from 'react';
import '../styles/_global.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="not-found-page">
          <h1>Something went wrong</h1>
          <p>Please try refreshing the page.</p>
          <a href="/" className="btn btn-primary">Back to home</a>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
